/**
 * JYTR — click-to-enlarge for product photos (product pages, included-item cards, detail images).
 * Images in the same gallery open as one set you can browse with arrows, keyboard or swipe.
 * Add data-zoom to any other <img> to make it enlargeable too.
 * (The limited edition story page has its own viewer, so it's skipped here.)
 */
(function () {
  var BASE = ['.product-media img', '.gallery-main img[data-gallery-image]', 'img[data-zoom]'];
  // Only on product pages: "What's inside" card images and full-width detail images
  var PRODUCT_ONLY = ['.card-grid .card .stage img', '.section-head + img'];
  var GROUPS = '.product-media, .gallery-main, .card-grid';

  function fullSize(src) {
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$12400').replace(/([?&]height=)\d+/, '$12400');
    return src;
  }

  function init() {
    if (document.querySelector('.edition-zoom')) return;
    var sel = BASE.concat(document.querySelector('.product-layout, .product-gallery') ? PRODUCT_ONLY : []).join(',');
    var imgs = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (im) {
      return im.getAttribute('src') && !im.closest('a, button');
    });
    if (!imgs.length) return;

    var css = document.createElement('style');
    css.textContent = [
      '.jz-target{cursor:zoom-in}',
      '.jz-target:focus-visible{outline:2px solid var(--accent);outline-offset:-2px}',
      '.jz-box{width:100vw;height:100vh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:rgba(10,10,11,0.94);color:var(--text)}',
      '.jz-box[open]{display:flex;align-items:center;justify-content:center}',
      '.jz-box::backdrop{background:rgba(10,10,11,0.94)}',
      '.jz-img{max-width:calc(100vw - 140px);max-height:calc(100vh - 110px);width:auto;height:auto;object-fit:contain;border-radius:12px;background:var(--bg-elev)}',
      '.jz-btn{position:absolute;display:flex;align-items:center;justify-content:center;width:44px;height:44px;border-radius:999px;background:var(--bg-elev);border:1px solid var(--line);color:var(--text);cursor:pointer;font-size:26px;line-height:1;padding:0}',
      '.jz-btn:hover{border-color:var(--accent);color:var(--accent)}',
      '.jz-close{top:calc(18px + env(safe-area-inset-top,0px));right:18px}',
      '.jz-prev{left:18px;top:50%;transform:translateY(-50%)}',
      '.jz-next{right:18px;top:50%;transform:translateY(-50%)}',
      '.jz-box.single .jz-prev,.jz-box.single .jz-next{display:none}',
      '.jz-count{position:absolute;bottom:calc(18px + env(safe-area-inset-bottom,0px));left:0;right:0;text-align:center;color:var(--text-dim);margin:0}',
      '@media(max-width:640px){.jz-img{max-width:100vw;max-height:calc(100vh - 140px);border-radius:0}.jz-prev,.jz-next{top:auto;bottom:calc(10px + env(safe-area-inset-bottom,0px));transform:none}}'
    ].join('');
    document.head.appendChild(css);

    var dlg = document.createElement('dialog');
    dlg.className = 'jz-box';
    dlg.setAttribute('aria-label', 'Image viewer');
    dlg.innerHTML = '<button type="button" class="jz-btn jz-close" aria-label="Close">&times;</button>' +
      '<button type="button" class="jz-btn jz-prev" aria-label="Previous image">&#8249;</button>' +
      '<img class="jz-img" alt="">' +
      '<button type="button" class="jz-btn jz-next" aria-label="Next image">&#8250;</button>' +
      '<p class="jz-count mono"></p>';
    document.body.appendChild(dlg);
    if (typeof dlg.showModal !== 'function') return;
    var big = dlg.querySelector('.jz-img'), count = dlg.querySelector('.jz-count');
    var group = [], index = 0, opener = null;

    function show(i) {
      index = (i + group.length) % group.length;
      var im = group[index];
      big.src = fullSize(im.currentSrc || im.src);
      big.alt = im.alt || '';
      count.textContent = group.length > 1 ? (index + 1) + ' / ' + group.length : '';
      dlg.classList.toggle('single', group.length < 2);
    }
    function open(im) {
      var box = im.closest(GROUPS);
      group = box ? imgs.filter(function (x) { return box.contains(x); }) : [im];
      opener = im;
      show(group.indexOf(im));
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
    }

    imgs.forEach(function (im) {
      im.classList.add('jz-target');
      im.setAttribute('tabindex', '0');
      im.setAttribute('role', 'button');
      im.setAttribute('aria-label', 'Enlarge image' + (im.alt ? ': ' + im.alt : ''));
      im.addEventListener('click', function () { open(im); });
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(im); }
      });
    });

    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      big.removeAttribute('src');
      if (opener) opener.focus();
    });
    dlg.querySelector('.jz-close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.jz-prev').addEventListener('click', function () { show(index - 1); });
    dlg.querySelector('.jz-next').addEventListener('click', function () { show(index + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
    var startX = null;
    dlg.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (startX === null || group.length < 2) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
